"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDITOR_HELP = exports.CHARITY_GIFTS = exports.PERSONAL_GIFTS = exports.INSIDER_DEBT_HELP = exports.INSIDER_PAYMENT = exports.OVERPAYMENT = exports.CASH_ADVANCE = exports.LUXURY_ITEM = exports.NEW_LARGE_DEBTS = exports.INACCURATE_TAX_RETURNS = exports.TAX_REFUND = exports.BANKRUPTCY_CONSEQUENCES = void 0;
exports.BANKRUPTCY_CONSEQUENCES = "bankruptcyConsequences";
exports.TAX_REFUND = "taxRefund";
exports.INACCURATE_TAX_RETURNS = "inaccurateTaxReturns";
exports.NEW_LARGE_DEBTS = "newLargeDebts";
exports.LUXURY_ITEM = "luxuryItem";
exports.CASH_ADVANCE = "cashAdvance";
exports.OVERPAYMENT = "overpayment";
exports.INSIDER_PAYMENT = "insiderPayment";
exports.INSIDER_DEBT_HELP = "insiderDebtHelp";
exports.PERSONAL_GIFTS = "personalGifts";
exports.CHARITY_GIFTS = "charityGifts";
exports.CREDITOR_HELP = "creditorHelp";